/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { AddressSummaryResponse } from "./AddressSummaryResponse.ts";
import type { HTTPValidationError } from "./HTTPValidationError.ts";

export type AddressSummaryV1AddressAddressGetPathParams = {
	/**
	 * @type string
	 */
	address: string;
};

export const addressSummaryV1AddressAddressGetQueryParamsNetworkEnum = {
	REGTEST: "REGTEST",
	MAINNET: "MAINNET",
} as const;

export type AddressSummaryV1AddressAddressGetQueryParamsNetworkEnum =
	(typeof addressSummaryV1AddressAddressGetQueryParamsNetworkEnum)[keyof typeof addressSummaryV1AddressAddressGetQueryParamsNetworkEnum];

export type AddressSummaryV1AddressAddressGetQueryParams = {
	/**
	 * @type string
	 */
	network: AddressSummaryV1AddressAddressGetQueryParamsNetworkEnum;
};

/**
 * @description Successful Response
 */
export type AddressSummaryV1AddressAddressGet200 = AddressSummaryResponse;

/**
 * @description Validation Error
 */
export type AddressSummaryV1AddressAddressGet422 = HTTPValidationError;

export type AddressSummaryV1AddressAddressGetQueryResponse =
	AddressSummaryV1AddressAddressGet200;

export type AddressSummaryV1AddressAddressGetQuery = {
	Response: AddressSummaryV1AddressAddressGet200;
	PathParams: AddressSummaryV1AddressAddressGetPathParams;
	QueryParams: AddressSummaryV1AddressAddressGetQueryParams;
	Errors: AddressSummaryV1AddressAddressGet422;
};
